// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preview-class .anticon-left,\n.preview-class .anticon-right {\n  font-size: 60px;\n  color: rgba(231, 230, 230, 0.75);\n  cursor: pointer;\n}\n.preview-class .anticon-left {\n  position: absolute;\n  left: 15px;\n  bottom: 40%;\n}\n.preview-class .anticon-right {\n  position: absolute;\n  right: 15px;\n  bottom: 40%;\n}", ""]);
// Exports
module.exports = exports;
